import api from "./client";

export interface StatsBucket {
  day: string; // YYYY-MM-DD
  count: number;
}

export interface StatsTop {
  // nullable on the backend (rows where the grouped column is NULL
  // still show up for utm_source). We render `∅` for those.
  label: string | null;
  count: number;
}

export interface StatsOverview {
  total_leads: number;
  leads_last_30_days: number;
  leads_per_day: StatsBucket[];
  top_utm_sources: StatsTop[];
  top_states: StatsTop[];
  top_sugar_statuses: StatsTop[];
}

export async function getStatsOverview(): Promise<StatsOverview> {
  const { data } = await api.get<StatsOverview>("/api/stats/overview");
  return data;
}
